import Model, { attr, belongsTo } from "@ember-data/model";
import type HealthCentre from "./health-centre";

export default class CareGiver extends Model {
  @attr("string") declare address: string;
  @attr("string") declare comments: string;
  @attr("string") declare email: string;
  @attr("string") declare firstName: string;
  @belongsTo("health-centre", {
    async: false,
    inverse: "careGivers"
  })
  declare healthCentre: HealthCentre;
  @attr("string") declare lastName: string;
  @attr("string") declare phone: string;
  @attr("string") declare role: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "care-giver": CareGiver;
  }
}
